module.exports = __webpack_public_path__ + "static/media/38-4.b6d53d67.mp3";